// english

export default {
  menu_interface_title: 'Menu And Interface Manage',

  // form
  menu_interface_form_menu: 'Parent Menu',
  menu_interface_form_menu_placeholder: 'Please select parent menu',
  menu_interface_form_auth_name: 'Auth Name',
  menu_interface_form_auth_name_placeholder: 'Please input authorization name',
  menu_interface_form_url: 'URL',
  menu_interface_form_auth_common: 'Common Auth',
  menu_interface_form_auth_common_help:
    "When checked, all users have permissions for this interface. Role's permission assignment is no longer displayed.",
  menu_interface_default_auth: '[Common]',

  // menu
  menu_btn_add: 'Add New Menu',
  menu_confirm_delete_title: 'Do you confirm to delete this menu?',
  menu_confirm_delete_content_name: 'Menu Name: {name}',
  menu_confirm_delete_content_url: 'Menu URL: {name}',
  menu_delete_error: 'Cannot delete when there is an interface under the menu',

  menu_edit_title: 'Edit Menu',
  menu_add_title: 'Add New Menu',

  menu_form_name: 'Menu name',
  menu_form_name_placeholder: 'Please input menu name',
  menu_form_sort: 'Sort Number',
  menu_form_sort_help: 'Sort by small to large',
  menu_form_sort_placeholder: 'Please input sort number',
  menu_form_url_placeholder: 'Please input menu url',
  menu_table_parent_id: 'Parent Menu ID',
  menu_table_parent_name: 'Parent Menu Name',

  // interface
  interface_title: 'Interface List',
  interface_btn_add: 'Add New Interface',
  interface_edit_title: 'Edit Interface',
  interface_add_title: 'Add New Interface',
  interface_confirm_delete_title: 'Do you confirm to delete this interface?',
  interface_confirm_delete_content_name: 'Interface Name: {name}',
  interface_confirm_delete_content_url: 'Interface URL: {name}',
  interface_confirm_auth_access_tip: 'All users will have the access of this interface?',
  interface_form_name: 'Interface name',
  interface_form_name_placeholder: 'Please input name',

  interface_form_url_placeholder: 'Please input interface url',
  interface_form_method: 'Method',
  interface_form_method_placeholder: 'Please select method',
};
